import { QueryClient } from '@tanstack/react-query';

/**
 * Browser-side query cache (Redis plan Phase 9). Covers reads that go
 * straight from the browser to Supabase or to static public endpoints,
 * which the server-side Redis cache never sees. Zustand (src/lib/store.ts)
 * still owns app state; this only dedupes and reuses fetched data.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const queryKeys = {
  spendingAnalytics: (userId: string) => ['user', userId, 'spendingAnalytics'] as const,
  itemPriceHistory: (userId: string, slug: string) => ['user', userId, 'itemPriceHistory', slug] as const,
  restockSignals: (userId: string) => ['user', userId, 'restockSignals'] as const,
  user: (userId: string) => ['user', userId] as const,
};

/** Drops every cached read for a user; call after their purchase history changes. */
export const invalidateUserData = (userId: string) =>
  queryClient.invalidateQueries({ queryKey: queryKeys.user(userId) });
